import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id CE677999-FD3D-4120-A755-2EF579A82528
 * name monitor-small
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-small.svg
 * tags
 * - Device / Tech 
 */
export const MonitorSmallIcon = createSvgIcon(<><path d="M19 2H5C3.89 2 3 2.89 3 4V16C3 17.11 3.9 18 5 18H10V20H8V22H16V20H14V18H19C20.11 18 21 17.11 21 16V4C21 2.89 20.1 2 19 2M19 16H5V4H19V16Z" /></>, 'MonitorSmallIcon');
export default MonitorSmallIcon